import cn from 'classnames';
import OpRadio from 'components/Common/op-ui-wrappers/OpRadio/OpRadio';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import isDesktop from 'store/app/selector/isDesktop';
import OpThumbnail from '../../../Common/op-ui-wrappers/OpThumbnail/OpThumbnail';
import BaseSelector from '../BaseSelector/BaseSelector';
import { BasketItemSelectorProps } from '../types';
import useAvailableSelectorsHook from '../useAvailableSelectorsHook';
import styles from './BasketItemEnvelopesSelector.module.scss';

const BasketItemEnvelopesSelector: FC<BasketItemSelectorProps> = ({ onChangeSelector, orderItemId, selector }) => {
  const isDesktopDevice = useSelector(isDesktop);
  const { getSelectors, selectors, loading, selectedSelector, setSelectedSelector } = useAvailableSelectorsHook(
    orderItemId,
    'envelopes',
  );
  const { t } = useTranslation();
  const [envelopeApplied, setEnvelopeApplied] = useState(false);

  return (
    <BaseSelector
      actionString={t('txt_select_envelope')}
      buttonHeading={t('txt_add_envelope')}
      thumbnail=""
      title={t('txt_add_envelope')}
      selectorApplied={envelopeApplied}
      applySelector={() => {}}
      removeSelector={() => {}}
      type="complex"
      onContentOpen={() => {
        getSelectors();
      }}
    >
      {isDesktopDevice ? (
        <div className={styles.content}>
          <OpText className={styles.envelopeName} variant="body" size="medium">
            {selectedSelector?.name}
          </OpText>
          <div className={styles.envelopes}>
            {selectors.map((envelope) => (
              <div className={styles.envelope} onClick={() => setSelectedSelector(envelope)}>
                <div
                  className={cn(styles.envelopePreview, {
                    [styles.envelopeSelected]: selectedSelector?.id === envelope?.id,
                  })}
                >
                  <OpThumbnail src={envelope?.thumbnailUrl || ''} size="large" />
                </div>
                <div className={styles.radioButton}>
                  <OpRadio checked={selectedSelector?.id === envelope?.id ? true : undefined}>
                    <OpText>
                      <div slot="heading">{envelope?.name}</div>
                    </OpText>
                  </OpRadio>
                </div>
                <div className={styles.pricePerUnit}>{envelope?.price?.initial?.formatted}</div>
                <div className={styles.description}>
                  <OpText variant="body" size="small">
                    {envelope?.description}
                  </OpText>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.mobileContent}>
          <div className={styles.envelopeCarousel}>
            <div className={styles.envelopeCarouselPreview}>
              <OpThumbnail src={selectedSelector?.thumbnailUrl || ''} size="fluid" />
            </div>
            <div className={styles.envelopeCarouselItems}>
              {selectors.map((envelope) => (
                <div className={styles.envelopeCarouselItem} onClick={() => setSelectedSelector(envelope)}>
                  <OpThumbnail
                    src={envelope?.thumbnailUrl || ''}
                    size="small-1x"
                    selected={selectedSelector?.id === envelope?.id}
                  />
                </div>
              ))}
            </div>
          </div>
          <OpText className={styles.envelopeName} variant="body" size="large">
            {selectedSelector?.name}
          </OpText>
          <OpText className={styles.pricePerUnit} variant="body" size="small">
            {selectedSelector?.price?.initial?.formatted}
          </OpText>
          <OpText className={styles.description} variant="title" size="small">
            {selectedSelector?.description}
          </OpText>
        </div>
      )}
    </BaseSelector>
  );
};

export default BasketItemEnvelopesSelector;
